import type { ObjPathProxy } from "ts-object-path";
import { ClientIdentificationDocumentTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type ResourceString = ObjPathProxy<MyPlannResourceDictionary, string>;

type PaperworkDocCategoryId =
	| "personal"
	| "vehicles"
	| "sport"
	| "insurance"
	| "other";

export type PaperworkDocTone = "blue" | "orange" | "green" | "red" | "gray";

export type PaperworkDocType = {
	id: ClientIdentificationDocumentTypeEnum;
	name: ResourceString;
	isCustom?: boolean;
};

export type PaperworkDocCategory = {
	id: PaperworkDocCategoryId;
	label: ResourceString;
	tone: PaperworkDocTone;
	types: PaperworkDocType[];
};

const R = Resources.Paperwork;
const Types = ClientIdentificationDocumentTypeEnum;

export const PAPERWORK_DOC_CATEGORIES: PaperworkDocCategory[] = [
	{
		id: "personal",
		label: R.Upload.Categories.personal,
		tone: "blue",
		types: [
			{ id: Types.IdentityCard, name: R.Types.IdentityCard },
			{ id: Types.Passport, name: R.Types.Passport },
			{ id: Types.ResidencePermit, name: R.Types.ResidencePermit },
			{ id: Types.ISIC, name: R.Types.ISIC },
			{ id: Types.TravelLicense, name: R.Types.TravelLicense },
		],
	},
	{
		id: "vehicles",
		label: R.Upload.Categories.vehicles,
		tone: "orange",
		types: [
			{ id: Types.DrivingLicense, name: R.Types.DrivingLicense },
			{ id: Types.STK, name: R.Types.STK },
			{ id: Types.ShipLicense, name: R.Types.ShipLicense },
			{ id: Types.PilotLicense, name: R.Types.PilotLicense },
		],
	},
	{
		id: "sport",
		label: R.Upload.Categories.sport,
		tone: "green",
		types: [
			{ id: Types.WeaponLicense, name: R.Types.WeaponLicense },
			{ id: Types.FishingLicense, name: R.Types.FishingLicense },
			{ id: Types.HuntingLicense, name: R.Types.HuntingLicense },
		],
	},
	{
		id: "insurance",
		label: R.Upload.Categories.insurance,
		tone: "red",
		types: [{ id: Types.InsuranceCard, name: R.Types.InsuranceCard }],
	},
	{
		id: "other",
		label: R.Upload.Categories.other,
		tone: "gray",
		types: [{ id: Types.Other, name: R.Types.Other, isCustom: true }],
	},
];

export const PAPERWORK_DOC_TYPES: PaperworkDocType[] =
	PAPERWORK_DOC_CATEGORIES.flatMap((category) => category.types);
